import React from "react";

import style from "./spacing.module.scss";

interface SpacingProps {
    size: "compact" | "expanded";
}

export const Spacing = ({ size }: SpacingProps): JSX.Element => {
    return <div className={`${style.wrapper} ${style[size]}`} data-test-id="spacing" />;
};

export default Spacing;
